var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-16.25268 -19.507125 140.85656 117.04275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3712 0c-2 0-8.36.63-8.36 8.78v57.9c0 .07-.34 5.72 2.72 9a7.75 7.75 0 005.92 2.34 9 9 0 005.88-2.36 1.5 1.5 0 011.33 0 2 2 0 01.71 1.72h1.1V41.07h2.72v-1h-11.55v1h3.39v31.2a5.54 5.54 0 01-1 3.83 3.28 3.28 0 01-2.56 1 2.89 2.89 0 01-2.15-.88c-1.08-1.11-1.59-3.2-1.51-6.21V6.47c0-.23.25-5.5 3.16-5.5s6.39 7.34 7.58 21.37v2.21h1V.65h-1V2.6l-.09.06a1.41 1.41 0 01-.78.26 2.31 2.31 0 01-1-.61A9.12 9.12 0 008.3712 0zm79 77.44h12.58v-1h-4.35V46.19h5.4a6.91 6.91 0 007.35-6.69V8.77c0-7.4-9.47-7.54-9.56-7.54h-11.7v1h3v74.24h-2.76v1zm-31.6-.1h11.59v-1h-3.08l-8.33-75.07h-4.53c-.41 3.93-7.4 71-7.4 71.92a3.27 3.27 0 01-3.12 3.16h-.59v1h8.1v-1h-.43a3 3 0 01-2.86-3.31l2.8-27.09h7.54l3.26 30.4h-3v1zm40.1-32.41h-.19V2.31h3.19c3.71 0 4.29 4.93 4.29 5v33.16c0 4.34-3.27 4.44-3.3 4.44h-4zm-40.43-.19h-7.33v-.21l3.62-34.12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGap);
export default __webpack_public_path__ + "static/media/Gap.d75d275d54b132ca7b8aadfd2e373e88.svg";
export { ForwardRef as ReactComponent };